import { createDynamicSlice } from ".";
import { fetchSettingsThunk } from "../thunks/settingsThunk";

export const settingsSlice = createDynamicSlice({
  name: "settings",
  thunk: fetchSettingsThunk,
  listMode: true,
  resetActionName: "resetSettings",
});

export const settingsReducer = settingsSlice.reducer;
export const { resetSettings } = settingsSlice.actions;
